import { api } from "@/client/api"

export default {

    changeCreditLimit(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/account/change-credit-limit`, request)
    }
}
